import { useCallback } from 'react';
import { useAppDispatch } from '@editor2/store';
import { debounce } from 'lodash-es';
import { type Action, type AnyAction } from 'redux';

export const useDebouncedDispatch = (waitMs = 500) => {
	const dispatch = useAppDispatch();
	return useCallback(
		debounce(<A extends Action = AnyAction>(action: A) => dispatch(action), waitMs),
		[]
	);
};
